import React, {
  useEffect, useState,
} from 'react';
import {
  observer,
} from 'mobx-react';
import {
  TextField, Button, Card, CardActions, CardContent, CardHeader, Typography, FormControl, Select, MenuItem, Theme, useTheme,
} from '@material-ui/core';
import {
  stores, RequestStatus,
} from 'mobx-store';
import {
  useHistory, useLocation, useParams,
} from 'react-router';
import SearchFilterDropdown from 'components/SearchFilterComponent/SearchFilterDropdown';
import Spinner from 'components/Spinner';
import styles from './styles.module.scss';
import WidgetsPreview, {
  calcContainerHeight,
} from './gridComponent';
import {
  WidgetKeys, WidgetInstance, CustomScreen,
} from '../../mobx-store/stores/customScreens/types';
import GeneralWidgetCard from './widgetsCardData/generalWidgetCard';
import IconWidgetCard from './widgetsCardData/iconWidgetCard';
import HorizontalWidgetCard from './widgetsCardData/horizontalWidgetCard';
import {
  ColorPalette, horizontalWidgetType,
} from './widgetsCardData/horizontalWidgetCard/types';
import VerticalWidgetCard from './widgetsCardData/verticalWidgetCard';
import ImageWidgetCard from './widgetsCardData/imageWidgetCard';
import { IconWidgetType } from './widgetsCardData/iconWidgetCard/types';
import CustomSelectInput from 'components/GeneralFormView/FormField/SelectField/CustomSelectInput';
import {
  MenuProps, useStyles,
} from 'components/GeneralFormView/FormField/SelectField';
import CustomSelectInputLabel from 'components/GeneralFormView/FormField/SelectField/CustomSelectInputLabel';
import ClubOccupancyWidgetCard from './widgetsCardData/clubOccupancyWidgetCard';
import SliderWidgetCard from './widgetsCardData/SliderWidgetCard';
import ThumbnailWidgetCard from './widgetsCardData/thumbnailWidgetCard';
import { ICountry } from 'mobx-store/storeInterfaces/authInterface';
import { countriesIsoCodes } from 'constants/countries';
import TitleWidgetCard from './widgetsCardData/titleWidgetCard';
import TabWidgetCard from './widgetsCardData/tabWidgetCard';
import SmartWidgetCard from './widgetsCardData/SmartWidgetCard';
import { getFormErrorState, ValidFormResponse } from './widgetsCardData/validation.helper';
import DescriptionWidgetCard from './widgetsCardData/descriptionWidgetCard';
import { translate } from 'helperFunctions/translation';
import DangerIconButton from 'components/DangerIconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import HomePointsWidgetCard from './widgetsCardData/HomePointsWidgetCard';

interface Props {
  match: any;
}

const COLUMN_COUNT = 24;

const PREVIEW_WIDTH = 360;

const getUnitLength = (columnCount: number, width: number) => width / columnCount;

const getStyles = (value: string, selectedValues: string[], theme: Theme) => ({
  fontWeight:
    !selectedValues.includes(value)
      ? theme.typography.fontWeightRegular
      : theme.typography.fontWeightMedium,
});

const AddEditCustomScreen: React.FC<Props> = (props) => {
  const {
    customScreens,
  } = stores.customScreenStore.Stores;

  const [customScreenTitle, setCustomScreenTitle] = useState('');

  const [customScreenKey, setCustomScreenKey] = useState('');

  const [widgetKey, setWidgetKey] = useState(WidgetKeys.GENERAL_WIDGET);

  const [widgets, setWidgets] = useState<WidgetInstance[]>([]);

  const [widgetCounter, setWidgetCounter] = useState(0);

  const [focusedWidget, setFocusedWidget] = useState<null | string | number>(null);

  const defaultLang = 'ar';
  const otherLanguages = ['en'];

  const classes = useStyles();
  const theme = useTheme();

  const history = useHistory();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const paramLang = queryParams.get('lang');
  const [languages] = useState<string[]>([defaultLang, ...otherLanguages]);
  const isLastLanguage = languages.indexOf(paramLang || defaultLang) + 1 === languages.length;
  const [formErrorState, setFormErrorState] = useState<ValidFormResponse>({ valid: true });
  const {
    customScreenKeyParam,
  } = useParams<{ customScreenKeyParam: string }>();
  const isEditting = !!customScreenKeyParam;


  useEffect(
    () => {
      const onLocationChange = async () => {
        if (
          !paramLang
          || !languages.includes(paramLang)
          || (!customScreenKeyParam && paramLang !== defaultLang)
        ) {
          history.replace({
            pathname: location.pathname,
            search: `?lang=${defaultLang}`,
          });
        }
        if (isEditting) {
          await customScreens.getCustomScreen(customScreenKeyParam, paramLang || defaultLang);
          setCustomScreenKey(customScreens.customScreen.customScreenKey);
          setCustomScreenTitle(customScreens.customScreen.name);
          setWidgets(customScreens.customScreen.widgetInstances);
          setFocusedWidget(null);
          setWidgetCounter(0);
        }


      };
      onLocationChange();
    },
    [
      paramLang,
      customScreenKeyParam,
      isEditting,
    ],
  );

  //   useEffect(() => {
  //     const getData = async () => {
  //       if (props.match.params.customScreenKey) {
  //         await customScreens.getCustomScreen(props.match.params.customScreenKey);
  //         setCustomScreenKey(customScreens.customScreen.customScreenKey);
  //         setCustomScreenTitle(customScreens.customScreen.name);
  //         setWidgets(customScreens.customScreen.widgetInstances);
  //         setFocusedWidget(null);
  //         setWidgetCounter(0);
  //       }
  //     };

  //     getData();
  //   }, []);

  const ErrorMessage = (errorProps: {case: boolean, msg: string}) =>{
    if(!errorProps.case) {
      return null;
    }
    return(<h6 className={styles.error}>{errorProps.msg}</h6>)
  }

  const handleCustomScreenTitleChange = (event: any) => {
    setCustomScreenTitle(event.target.value);
  };

  const handleCustomScreenKeyChange = (event: any) => {
    setCustomScreenKey(event.target.value);
  };

  const handleChange = (key: string, value: string) => {
    const currentWidget = widgets.findIndex((widget) => widget.widgetInstanceId.toString() === focusedWidget?.toString());
    if (currentWidget !== -1) {
      const widgetsCopy = widgets.slice(0);
      widgetsCopy[currentWidget] = {
        ...widgets[currentWidget],
        params: {
          ...widgets[currentWidget].params,
          [key]: value,
        },
      };
      if(widgetsCopy[currentWidget].widgetKey !== WidgetKeys.SLIDER_WIDGET) {
        setFormErrorState(
          getFormErrorState(
            widgetsCopy[currentWidget].widgetKey,
            widgetsCopy[currentWidget].params
          )
        );
      }
      setWidgets(widgetsCopy);
    }
  };
  const handleMultipleChange = (params: {}) => {
    const currentWidget = widgets.findIndex((widget) => widget.widgetInstanceId.toString() === focusedWidget?.toString());
    if (currentWidget === -1) { return; }
    const widgetsCopy = widgets.slice(0);
    widgetsCopy[currentWidget] = {
      ...widgets[currentWidget],
      params: {
        ...widgets[currentWidget].params,
        ...params
      },
    };
    if(widgetsCopy[currentWidget].widgetKey !== WidgetKeys.SLIDER_WIDGET) {
      setFormErrorState(
        getFormErrorState(
          widgetsCopy[currentWidget].widgetKey,
          widgetsCopy[currentWidget].params
        )
      );
    }
    setWidgets(widgetsCopy);
  };




  const onClickAddWidget = () => {

    if(!formErrorState.valid) {
      notAllowedToChangeCurrentWidget();
      return;
    }
    const newWidget: WidgetInstance = {
      height: 12,
      width: 24,
      params: {
        title: ''
      },
      startX: 0,
      startY: calcContainerHeight(widgets),
      widgetInstanceId: `UNTRACKED-${widgetCounter}`,
      widgetKey,
    };
    setFormErrorState(
      getFormErrorState(
        newWidget.widgetKey,
        newWidget.params
      )
    );

    setWidgets([
      ...widgets,
      newWidget,
    ]);
    setFocusedWidget(`UNTRACKED-${widgetCounter}`);
    setWidgetCounter(widgetCounter + 1);
  };

  const removeFocusedWidget = () => {
    if (focusedWidget !== null) {
      const newWidgets = widgets.slice(0);
      const focusedWidgetIndex = widgets.findIndex((widget) => widget.widgetInstanceId === focusedWidget);
      if (focusedWidgetIndex !== -1) {
        newWidgets.splice(focusedWidgetIndex, 1);
        setFormErrorState({
          valid: true
        })
        setFocusedWidget(null);
        setWidgets(newWidgets);
      }
    }
  };

  const removeLastRoute = (path: string) => path.slice(0, path.lastIndexOf('/'));

  const getBaseURL = (pathName: string) => {
    let returnValue = removeLastRoute(pathName);
    if (pathName.includes('edit')) {
      returnValue = removeLastRoute(returnValue);
    }
    return returnValue;
  };

  const handleAddCustomScreen = async () => {
    const customScreenData: CustomScreen = {
      customScreenKey,
      name: customScreenTitle,
      widgetInstances: widgets,
    };
    const baseURL: string = getBaseURL(location.pathname);
    if (isEditting) {
      await customScreens.updateCustomScreen(customScreenData, paramLang || defaultLang);
      if (isLastLanguage || stores.countryStore.managedCountries.some((country: ICountry) => country.isoCode === countriesIsoCodes.kenya)) {
        history.push(baseURL);
      } else {
        const index = languages.indexOf(paramLang || defaultLang);
        const nextLang = languages[index + 1];
        history.push({
          pathname: `${baseURL}/${customScreenKeyParam}/edit`,
          search: `?lang=${nextLang}`,
        });
      }
    } else {
      await stores.countryStore.getUserManagedCountries();
      const screenName = await customScreens.createCustomScreen(customScreenData, paramLang || defaultLang, stores.countryStore.managedCountries);
      if (isLastLanguage || stores.countryStore.managedCountries.some((country: ICountry) => country.isoCode === countriesIsoCodes.kenya)) {
        history.push(baseURL);
      } else {
        const index = languages.indexOf(paramLang || defaultLang);
        const nextLang = languages[index + 1];
        history.push({
          pathname: `${baseURL}/${screenName}/edit`,
          search: `?lang=${nextLang}`,
        });
      }
    }
  };

  let focusedWidgetData: WidgetInstance | undefined;

  if (focusedWidget) {
    focusedWidgetData = widgets.find((widget) => widget.widgetInstanceId.toString() === focusedWidget.toString());
  }

  const renderCardHeader = () => {
    if (!focusedWidgetData) {
      return null;
    }
    return (
      <CardHeader
        title={focusedWidgetData.widgetKey.replaceAll('_', ' ')}
        action={(
          <DangerIconButton onClick={removeFocusedWidget}>
            <DeleteIcon />
          </DangerIconButton>
        )}
      />
    );
  };

  const renderWidgetForm = () => {
    if (!focusedWidgetData) {
      return (<h4 className={styles.noWidget}>{translate('selectWidget')}</h4>);
    }
    if (focusedWidgetData.widgetKey === WidgetKeys.GENERAL_WIDGET) {
      return (
        <GeneralWidgetCard
          focusedWidget={focusedWidget}
          focusedWidgetData={focusedWidgetData}
          handleChangeData={handleChange}
          removeFocusedWidget={removeFocusedWidget}
        />
      );
    }
    if (focusedWidgetData.widgetKey === WidgetKeys.HORIZONTAL_WIDGET) {
      return (
        <HorizontalWidgetCard
          focusedWidget={focusedWidget}
          focusedWidgetData={focusedWidgetData}
          handleChangeData={handleChange}
          removeFocusedWidget={removeFocusedWidget}
          handleMultipleChangeData={handleMultipleChange}
        />
      );
    }
    if (focusedWidgetData.widgetKey === WidgetKeys.ICON_WIDGET) {
      return (
        <IconWidgetCard
          focusedWidget={focusedWidget}
          focusedWidgetData={focusedWidgetData}
          handleChangeData={handleChange}
          removeFocusedWidget={removeFocusedWidget}
          handleMultipleChangeData={handleMultipleChange}
        />
      );
    }
    if (focusedWidgetData.widgetKey === WidgetKeys.VERTICAL_WIDGET) {
      return (
        <VerticalWidgetCard
          focusedWidget={focusedWidget}
          focusedWidgetData={focusedWidgetData}
          handleChangeData={handleChange}
          removeFocusedWidget={removeFocusedWidget}
          handleMultipleChangeData={handleMultipleChange}
        />
      );
    }
    if (focusedWidgetData.widgetKey === WidgetKeys.IMAGE_WIDGET) {
      return (
        <ImageWidgetCard
          focusedWidget={focusedWidget}
          focusedWidgetData={focusedWidgetData}
          handleChangeData={handleChange}
          handleMultipleChangeData={handleMultipleChange}
          removeFocusedWidget={removeFocusedWidget}
        />
      );
    }
    if (focusedWidgetData.widgetKey === WidgetKeys.CLUB_OCCUPANCY_WIDGET) {
      return (
        <ClubOccupancyWidgetCard
          focusedWidget={focusedWidget}
          focusedWidgetData={focusedWidgetData}
          handleChangeData={handleChange}
          removeFocusedWidget={removeFocusedWidget}
        />
      );
    }
    if (focusedWidgetData.widgetKey === WidgetKeys.SLIDER_WIDGET) {
      return (
        <SliderWidgetCard
          focusedWidget={focusedWidget}
          focusedWidgetData={focusedWidgetData}
          handleChangeData={handleChange}
          removeFocusedWidget={removeFocusedWidget}
          handleMultipleChangeData={handleMultipleChange}
          setErrorState={(sliderState: ValidFormResponse) => setFormErrorState(sliderState) }
          errorState={formErrorState}
        />
      );
    }
    if (focusedWidgetData.widgetKey === WidgetKeys.THUMBNAIL_WIDGET) {
      return (
        <ThumbnailWidgetCard
          focusedWidget={focusedWidget}
          focusedWidgetData={focusedWidgetData}
          handleChangeData={handleChange}
          removeFocusedWidget={removeFocusedWidget}
        />
      );
    }
    if (focusedWidgetData.widgetKey === WidgetKeys.TAB_WIDGET) {
      return (
        <TabWidgetCard
          focusedWidget={focusedWidget}
          focusedWidgetData={focusedWidgetData}
          handleChangeData={handleChange}
          removeFocusedWidget={removeFocusedWidget}
          handleMultipleChangeData={handleMultipleChange}
        />
      );
    }
    if (focusedWidgetData.widgetKey === WidgetKeys.TITLE_WIDGET) {
      return (
        <TitleWidgetCard
          focusedWidget={focusedWidget}
          focusedWidgetData={focusedWidgetData}
          handleChangeData={handleChange}
          removeFocusedWidget={removeFocusedWidget}
          handleMultipleChangeData={handleMultipleChange}
        />
      );
    }
    if (focusedWidgetData.widgetKey === WidgetKeys.DESCRIPTION_WIDGET) {
      return (
        <DescriptionWidgetCard
          focusedWidget={focusedWidget}
          focusedWidgetData={focusedWidgetData}
          handleChangeData={handleChange}
          removeFocusedWidget={removeFocusedWidget}
          handleMultipleChangeData={handleMultipleChange}
        />
      );
    }
    if(focusedWidgetData.widgetKey === WidgetKeys.HOME_POINTS_WIDGET) {
      return (
        <HomePointsWidgetCard
          focusedWidget={focusedWidget}
          focusedWidgetData={focusedWidgetData}
          handleChangeData={handleChange}
          removeFocusedWidget={removeFocusedWidget}
          handleMultipleChangeData={handleMultipleChange}
         />
      )
    }
    if (
      focusedWidgetData.widgetKey === WidgetKeys.ACCOUNT_CONTROL_WIDGET
      || focusedWidgetData.widgetKey === WidgetKeys.POINTS_WIDGET
      || focusedWidgetData.widgetKey === WidgetKeys.HEADER_INFO_WIDGET
      || focusedWidgetData.widgetKey === WidgetKeys.NO_POINTS_WIDGET
      || focusedWidgetData.widgetKey === WidgetKeys.CARD_RECEIVAL_WIDGET
    ) {
      return (
        <SmartWidgetCard
          focusedWidget={focusedWidget}
          focusedWidgetData={focusedWidgetData}
          handleChangeData={handleChange}
          removeFocusedWidget={removeFocusedWidget}
          handleMultipleChangeData={handleMultipleChange}
        />
      );
    }
  };

  const onLayoutChange = (layout: any) => {

    if (layout.length !== widgets.length) {
      return;
    }
    const newWidgets: WidgetInstance[] = [];
    layout.forEach((layoutI: any) => {
      const widget = widgets.find((widget) => widget.widgetInstanceId.toString() === layoutI.i);
      if (widget) {
        newWidgets.push({
          ...widget,
          startX: layoutI.x,
          startY: layoutI.y,
          width: layoutI.w,
          height: layoutI.h,
        });
      }
    });
    setWidgets(newWidgets);
  }

  const setFocusedWidgetItem = (item: string | number | null) => {
    if(formErrorState.valid) {
      setFocusedWidget(item);
    } else {
      notAllowedToChangeCurrentWidget();
    }
  };

  const notAllowedToChangeCurrentWidget = () => { 
    setFormErrorState({
      valid: false,
      message: `Please fill all required fields before focusing on another widget ex. ${formErrorState?.key}`,
      key: formErrorState?.key || 'General: '
    })
  };
  return (
    <>
      <div className={styles.headerLang}>
        <h4>{customScreenTitle || 'Create Custom Screen'}</h4>

        <div>
          {
            isEditting && (
              <FormControl variant="outlined" className={classes.formControl}>
                <Select
                  value={paramLang}
                  placeholder="Language"
                  onChange={(event) => {
                    const {
                      value,
                    } = event.target;
                    history.replace({
                      pathname: location.pathname,
                      search: `?lang=${value}`,
                    });
                  }}
                  // input={<CustomSelectInput />}
                  renderValue={((selected: string) => (
                    <Typography
                      variant="subtitle1"
                    >
                      {selected}
                    </Typography>
                  )) as any}
                  MenuProps={MenuProps}
                  style={{
                    width: 120,
                  }}
                >
                  {languages.map((item) => (
                    <MenuItem key={item} value={item} style={getStyles(item, languages, theme)}>
                      {item}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )
          }
        </div>
      </div>
      <div className={styles.widgetPreview}>
        <div className={styles.formPreview}>
          <div>
          {
            stores.countryStore.managedCountries.some((country: ICountry) => country.isoCode === countriesIsoCodes.egypt)
            && (
              <>
            <Typography
              variant="h6"
            >
              {paramLang === 'ar' ? "Arabic Content" : "English Content"}
            </Typography>
              </>
            )
          }
          <div className={styles.screenDetails}>
                <TextField
                  variant="outlined"
                  value={customScreenTitle}
                  onChange={handleCustomScreenTitleChange}
                  autoFocus
                  margin="dense"
                  id="screenTitle"
                  label="Screen Title"
                  fullWidth
                />
                <TextField
                  variant="outlined"
                  value={customScreenKey}
                  onChange={handleCustomScreenKeyChange}
                  autoFocus
                  margin="dense"
                  id="screenKey"
                  label="Screen key"
                  fullWidth
                  disabled={props.match.params.customScreenKeyParam}
                />
              </div>
        </div>
      
      <div className={styles.addWidgetDetails}>
        <SearchFilterDropdown
          label="Widget Types"
          searchFilterDropdown={{
            filters: Object.values(WidgetKeys).map((key) => ({
              value: key, name: key,
            })),
            value: widgetKey,
            initialValue: WidgetKeys.GENERAL_WIDGET,
            onChange: (status: WidgetKeys) => {
              setWidgetKey(status);
            },
          }}
        />
        <Button variant="contained" color="primary" onClick={onClickAddWidget}>Add Widget</Button>
      </div>
          <div>
            <div
              className={styles.widgetsContainer}
            >
              <Card
                className={styles.widgetFormContainer}
              >
                {
                  renderCardHeader()
                }
                {
                  customScreens.requestStatus === RequestStatus.LOADING
                    ? <Spinner size={50} />
                    : (
                      renderWidgetForm()
                    )
                }
              </Card>
            </div>
          </div>
      <CardActions className={styles.actionButtons}>
        <ErrorMessage
          case={!!focusedWidget && !formErrorState.valid}
          msg={`${formErrorState?.key}: ${formErrorState?.message?.toLowerCase()}`}
        />
        <Button
          variant="contained"
          color="primary"
          type="submit"
          onClick={handleAddCustomScreen}
          disabled={customScreens.createOrUpdaterequestStatus === RequestStatus.LOADING || !formErrorState.valid}
        >
          {
            customScreens.createOrUpdaterequestStatus === RequestStatus.LOADING
              ? <Spinner size={25} />
              : (
                isLastLanguage || isEditting || stores.countryStore.managedCountries.some((country: ICountry) => country.isoCode === countriesIsoCodes.kenya)
                  ? 'Submit'
                  : 'To Next Language0'
              )
          }
        </Button>
      </CardActions>
   
        </div>
        <div>
          {/* <CardContent> */}
            <Typography
              variant="h6"
            >
              Please select a widget to start editing.
            </Typography>
          {/* </CardContent> */}
          <WidgetsPreview
            width={PREVIEW_WIDTH}
            cols={COLUMN_COUNT}
            margin={[0, 0]}
            onLayoutChange={onLayoutChange}
            rowHeight={getUnitLength(COLUMN_COUNT, PREVIEW_WIDTH)}
            items={widgets}
            focusedItem={focusedWidget}
            setFocusedItem={setFocusedWidgetItem}
            requestStatus={customScreens.requestStatus}
          />
        </div>
      </div>
    </>
  );
};

export default observer(AddEditCustomScreen);
